import { createSelector } from 'selectors'

import { constants } from './tooltip-select.constant'

export const getTargets = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLSelectElement>>({ scope, selector: constants.selector.target }, true)

export const getSaveDataField = () => createSelector<HTMLElement>({ selector: constants.selector.saveData })
